export default __webpack_public_path__ + "static/media/lockNoBackground.4c00c6bb.svg";